//setDataInstructions
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  instructions: localStorage.getItem("dataInstructions")
    ? JSON.parse(localStorage.getItem("dataInstructions"))
    : null,
};

const instructionSlice = createSlice({
  name: "instructions",
  initialState,
  reducers: {
    setDataInstructions(state, action) {
      state.instructions = action.payload;
    },
  },
});

export const { setDataInstructions } = instructionSlice.actions;

export default instructionSlice.reducer;
